// extracted by mini-css-extract-plugin
export var currentMessage = "sermon-module--current-message--2aa4e";
export var embedContainer = "sermon-module--embed-container--4a560";
export var messageDetails = "sermon-module--message-details--4eae2";
export var messageNum = "sermon-module--message-num--8d94b";
export var messageParts = "sermon-module--message-parts--39f39";
export var messagesInSeries = "sermon-module--messages-in-series--462bb";
export var moreSermons = "sermon-module--more-sermons--43d5a";
export var seriesDetails = "sermon-module--series-details--351c3";